export default __webpack_public_path__ + "static/media/GA-Certificate.a3b6d621.pdf";